function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var t = /*#__PURE__*/function () {
  function t() {
    _classCallCheck(this, t);

    this.listeners = {};
  }

  _createClass(t, [{
    key: "on",
    value: function on(_t, e, s) {
      var _this = this;

      if (this.listeners[_t] || (this.listeners[_t] = new Set()), this.listeners[_t].add(e), null == s ? void 0 : s.once) {
        var _s = function _s() {
          _this.un(_t, _s), _this.un(_t, e);
        };

        return this.on(_t, _s), _s;
      }

      return function () {
        return _this.un(_t, e);
      };
    }
  }, {
    key: "un",
    value: function un(_t2, e) {
      var s;
      null === (s = this.listeners[_t2]) || void 0 === s || s.delete(e);
    }
  }, {
    key: "once",
    value: function once(_t3, e) {
      return this.on(_t3, e, {
        once: !0
      });
    }
  }, {
    key: "unAll",
    value: function unAll() {
      this.listeners = {};
    }
  }, {
    key: "emit",
    value: function emit(_t4) {
      for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        e[_key - 1] = arguments[_key];
      }

      this.listeners[_t4] && this.listeners[_t4].forEach(function (_t5) {
        return _t5.apply(void 0, e);
      });
    }
  }]);

  return t;
}();

var e = /*#__PURE__*/function (_t6) {
  _inherits(e, _t6);

  var _super = _createSuper(e);

  function e(t) {
    var _this2;

    _classCallCheck(this, e);

    _this2 = _super.call(this), _this2.subscriptions = [], _this2.options = t;
    return _this2;
  }

  _createClass(e, [{
    key: "onInit",
    value: function onInit() {}
  }, {
    key: "_init",
    value: function _init(t) {
      this.wavesurfer = t, this.onInit();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.emit("destroy"), this.subscriptions.forEach(function (t) {
        return t();
      });
    }
  }]);

  return e;
}(t);

function s(t, e) {
  var i = e.xmlns ? document.createElementNS(e.xmlns, t) : document.createElement(t);

  for (var _i2 = 0, _Object$entries = Object.entries(e); _i2 < _Object$entries.length; _i2++) {
    var _ref3 = _Object$entries[_i2];

    var _ref2 = _slicedToArray(_ref3, 2);

    var _t7 = _ref2[0];
    var _n2 = _ref2[1];
    if ("children" === _t7) for (var _i3 = 0, _Object$entries2 = Object.entries(e); _i3 < _Object$entries2.length; _i3++) {
      var _ref6 = _Object$entries2[_i3];

      var _ref5 = _slicedToArray(_ref6, 2);

      var _t8 = _ref5[0];
      var _n3 = _ref5[1];
      "string" == typeof _n3 ? i.appendChild(document.createTextNode(_n3)) : i.appendChild(s(_t8, _n3));
    } else "style" === _t7 ? Object.assign(i.style, _n2) : "textContent" === _t7 ? i.textContent = _n2 : i.setAttribute(_t7, _n2.toString());
  }

  return i;
}

function i(t, e, i) {
  var n = s(t, e || {});
  return null == i || i.appendChild(n), n;
}

var n = {
  lineWidth: 1,
  labelSize: 11
};

var r = /*#__PURE__*/function (_e2) {
  _inherits(r, _e2);

  var _super2 = _createSuper(r);

  function r(t) {
    var _this3;

    _classCallCheck(this, r);

    _this3 = _super2.call(this, t || {}), _this3.unsubscribe = function () {}, _this3.onPointerMove = function (t) {
      if (!_this3.wavesurfer) return;

      var e = _this3.wavesurfer.getWrapper().getBoundingClientRect(),
          s = e.width,
          i = t.clientX - e.left,
          n = Math.min(1, Math.max(0, i / s)),
          _r = Math.min(s - _this3.options.lineWidth - 1, i);

      _this3.wrapper.style.transform = "translateX(".concat(_r, "px)"), _this3.wrapper.style.opacity = "1";
      var o = _this3.wavesurfer.getDuration() || 0;
      _this3.label.textContent = _this3.formatTime(o * n);
      var a = _this3.label.offsetWidth;
      _this3.label.style.transform = _r + a > s ? "translateX(-".concat(a + _this3.options.lineWidth, "px)") : "", _this3.emit("hover", n);
    }, _this3.onPointerLeave = function () {
      _this3.wrapper.style.opacity = "0";
    }, _this3.options = Object.assign({}, n, t), _this3.wrapper = i("div", {
      part: "hover"
    }), _this3.label = i("span", {
      part: "hover-label"
    }, _this3.wrapper);
    return _this3;
  }

  _createClass(r, [{
    key: "addUnits",
    value: function addUnits(t) {
      return "".concat(t).concat("number" == typeof t ? "px" : "");
    }
  }, {
    key: "onInit",
    value: function onInit() {
      var _this4 = this;

      if (!this.wavesurfer) throw Error("WaveSurfer is not initialized");
      var t = this.wavesurfer.options,
          e = this.options.lineColor || t.cursorColor || t.progressColor;
      Object.assign(this.wrapper.style, {
        position: "absolute",
        zIndex: 10,
        left: 0,
        top: 0,
        height: "100%",
        pointerEvents: "none",
        borderLeft: "".concat(this.addUnits(this.options.lineWidth), " solid ").concat(e),
        opacity: "0",
        transition: "opacity .1s ease-in"
      }), Object.assign(this.label.style, {
        display: "block",
        backgroundColor: this.options.labelBackground,
        color: this.options.labelColor,
        fontSize: "".concat(this.addUnits(this.options.labelSize)),
        transition: "transform .1s ease-in",
        padding: "2px 3px"
      });
      var s = this.wavesurfer.getWrapper();
      s.appendChild(this.wrapper), s.addEventListener("pointermove", this.onPointerMove), s.addEventListener("pointerleave", this.onPointerLeave), s.addEventListener("wheel", this.onPointerMove), this.unsubscribe = function () {
        s.removeEventListener("pointermove", _this4.onPointerMove), s.removeEventListener("pointerleave", _this4.onPointerLeave), s.removeEventListener("wheel", _this4.onPointerLeave);
      };
    }
  }, {
    key: "formatTime",
    value: function formatTime(t) {
      return "".concat(Math.floor(t / 60), ":").concat("0".concat(Math.floor(t) % 60).slice(-2));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(r.prototype), "destroy", this).call(this), this.unsubscribe(), this.wrapper.remove();
    }
  }], [{
    key: "create",
    value: function create(t) {
      return new r(t);
    }
  }]);

  return r;
}(e);

export { r as default };